import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  asChild?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-navy text-white hover:bg-navy-light',
    secondary: 'bg-sand text-navy hover:bg-sand-dark',
    outline: 'border border-navy text-navy hover:bg-navy hover:text-white',
    ghost: 'text-navy hover:bg-navy/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <button ref={ref} className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-342" />;
});
Button.displayName = 'Button';